import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from 'app/core/storage/storage.service';
import { environment } from 'environments/environment';

/**
 * Podgląd klienta przez administratora: backend panelu przyjmuje klienta z nagłówka
 * X-Panel-View-Client wyłącznie od konta z rolą ADMIN (ClientScope). Klient zawsze widzi siebie.
 */
export const viewClientInterceptor: HttpInterceptorFn = (req, next) => {
    const storage = inject(StorageService);
    const externalId = storage.isClientMode() ? storage.user?.externalId : null;

    if (externalId && req.url.startsWith(environment.apiUrl)) {
        return next(req.clone({ setHeaders: { 'X-Panel-View-Client': String(externalId) } }));
    }

    return next(req);
};
